export default __webpack_public_path__ + "static/media/container-left.8fca0ae9.png";